class SolidarityService {

  constructor(SolidarityUserDataService, SolidarityInitialService) {
    'ngInject';
    this.initialDataService = SolidarityInitialService;
    this.userDataService = SolidarityUserDataService;
    this.loaded = false;
  }

  loadData() {
    if (!this.userDataService.isEmpty()) {
      return;
    }

    this.initialDataService.initMainData();
    this.employee = this.userDataService.getEmployee();
  }
}

export default SolidarityService;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/common/services/solidarity.service.js